import React from "react";
import "./app.css";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

export let gameStartSoundInfo = new Audio("../sound/gamestart.mp3");

function Info() {
  //let ambianceSound = new Audio("../sound/ambiance.mp3");
  //ambianceSound.loop = true;
  return (
    <div className="main">
      <div className="infoText">
        <ul>
          <li>
            304 is four players card game with two teams. You will be in the
            blue team, placed at the bottom of the table.
          </li>

          <li>
            32 cards, each player will get 8 cards. The game happens in 8
            rounds.
          </li>

          <li>
            Start the game by choosing the trump card (1st played card). It
            decides the trump suit (power cards)
          </li>
          <li>
            Then Bet on how much points your team can gather at the end of the
            game.
          </li>
          <li>
            Points : Jack = 3, nine = 2, ace = 1.1, 10 = 1, king = 0.3; queen =
            0.2
          </li>
          <li>The rest of the players should play the same suit(design).</li>
          <li>
            If no suit, they can play the power cards or any other cards, which
            will go wasted.
          </li>
          <li>
            the team with the top card wins and gets the sum of the points.
          </li>
          <li>
            At the End of the game, if the bet is won: Blue team scores, if not
            the advert team gets the the score with an extra point.
          </li>
          <li>Bet scores : 50 = 1 , 70 = 1.5, 100 = 2, 250 = 3, 304 = 4</li>
        </ul>
      </div>
      <div className="buttonBar">
        <Button
          size="large"
          variant="outlined"
          color="error"
          component={Link}
          to="/play"
          onClick={() => {
            //gameStartSoundInfo.play();
            //ambianceSound.play();
          }}
        >
          START GAME
        </Button>
      </div>
    </div>
  );
}

export default Info;
